import { c as _c } from "react/compiler-runtime";
import { Box, BoxProps } from '@chakra-ui/react';
import { useRef, useState } from 'react';
type Props = {
  bgColor?: BoxProps['bgColor'];
  children?: any;
  isScrollable?: boolean;
  maxHeight?: BoxProps['maxHeight'];
  maxShadowHeight?: number;
  shadowEndColor?: BoxProps['bgColor'];
  shadowHeight?: number;
  shadowStartColor?: BoxProps['bgColor'];
};
export const ScrollBoxWithShadows = props => {
  const $ = _c(27);
  const maxShadowHeight = props.maxShadowHeight || 20;
  const [scrollTop, setScrollTop] = useState(0);
  const [scrollBottom, setScrollBottom] = useState(100);
  const scrollBoxRef = useRef(null);
  const scrollContentRef = useRef(null);
  let t0;
  if ($[0] !== maxShadowHeight || $[1] !== props.maxHeight || $[2] !== props.shadowEndColor || $[3] !== props.shadowStartColor || $[4] !== scrollTop) {
    t0 = props.maxHeight ? {
      background: `linear-gradient(0deg, ${props.shadowStartColor || "rgba(39, 43, 53, 0)"} 0%, ${props.shadowEndColor || "#272B35"} 100%)`,
      content: "''",
      display: "block",
      height: `${Math.min(maxShadowHeight, scrollTop)}px`,
      position: "relative",
      marginBottom: `-${Math.min(maxShadowHeight, scrollTop)}px`,
      width: "100%",
      zIndex: 1,
      pointerEvents: "none"
    } : {};
    $[0] = maxShadowHeight;
    $[1] = props.maxHeight;
    $[2] = props.shadowEndColor;
    $[3] = props.shadowStartColor;
    $[4] = scrollTop;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const beforeStyles = t0;
  let t1;
  if ($[6] !== maxShadowHeight || $[7] !== props.maxHeight || $[8] !== props.shadowEndColor || $[9] !== props.shadowStartColor || $[10] !== scrollBottom) {
    t1 = props.maxHeight ? {
      background: `linear-gradient(180deg, ${props.shadowStartColor || "rgba(39, 43, 53, 0)"} 0%, ${props.shadowEndColor || "#272B35"} 100%)`,
      content: "''",
      display: "block",
      height: `${Math.min(maxShadowHeight, scrollBottom)}px`,
      position: "relative",
      marginTop: `-${Math.min(maxShadowHeight, scrollBottom)}px`,
      width: "100%",
      zIndex: 0,
      pointerEvents: "none"
    } : {};
    $[6] = maxShadowHeight;
    $[7] = props.maxHeight;
    $[8] = props.shadowEndColor;
    $[9] = props.shadowStartColor;
    $[10] = scrollBottom;
    $[11] = t1;
  } else {
    t1 = $[11];
  }
  const afterStyles = t1;
  const t2 = props.maxHeight || props.isScrollable ? "scroll" : null;
  let t3;
  if ($[12] !== t2) {
    t3 = {
      overflowY: t2
    };
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  let t4;
  if ($[14] !== props.maxHeight) {
    t4 = async ev => {
      setScrollTop(Math.abs(ev.target?.scrollTop));
      setScrollBottom(Math.abs(scrollContentRef.current.getBoundingClientRect().height - ((ev.target?.scrollTop || 0) + parseInt(props.maxHeight, 10))));
    };
    $[14] = props.maxHeight;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== props.children) {
    t5 = <Box ref={scrollContentRef}>{props.children}</Box>;
    $[16] = props.children;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== props.maxHeight || $[19] !== t3 || $[20] !== t4 || $[21] !== t5) {
    t6 = <Box ref={scrollBoxRef} maxHeight={props.maxHeight} css={t3} onScroll={t4}>{t5}</Box>;
    $[18] = props.maxHeight;
    $[19] = t3;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  let t7;
  if ($[23] !== afterStyles || $[24] !== beforeStyles || $[25] !== t6) {
    t7 = <Box _after={afterStyles} _before={beforeStyles} width="full">{t6}</Box>;
    $[23] = afterStyles;
    $[24] = beforeStyles;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  return t7;
};